import React from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import procurement from '../../../../assets/supply1.png';

const styles = StyleSheet.create({
    section: {
        margin: 10,
        marginTop: 20,
        paddingBottom: 20,
        paddingHorizontal: 30,
        textAlign: "justify",
        fontWeight: 400,
        color: "#222",
        lineHeight: 1.5,
    },
    text: {
        fontSize: 8.9,
        textAlign: "justify",
        fontWeight: 300,
        color: "#222",
        lineHeight: 1.5,
        marginBottom: 10,
    },
    boldText: {
        fontSize: 10,
        textAlign: "left",
        fontWeight: "bold",
        color: "#222",
        lineHeight: 2.0,
        marginBottom: 5,
    },
    footerTextLeft: {
        textAlign: "left",
        fontSize: 8.9,
    },
    textRight: {
        textAlign: "right",
        fontSize: 8.9,
        marginTop: -15,
    },
    textUnderline: {
        textDecoration: "underline",
        width: "100%",
        display:"block",
    },
});

export const PageFour = () => {
    return (
        <>
            <View break>
                <Image
                    src={procurement}
                    style={{
                        height: 120,
                        width: "100%",
                        marginTop: 20,
                        paddingRight: 30,
                        paddingLeft: 30,
                        marginBottom: 0,
                    }} 
                />
                <View style={styles.section}>
                    <Text style={styles.boldText}>8. SELLER RESPONSIBLE FOR TAXES AND RECORDS.</Text>
                    
                    <Text style={styles.text}>
                        Seller shall be solely responsible for filing the appropriate federal, state and local tax forms and paying all such taxes or fees, including estimated taxes and employment taxes, due with respect to Seller's receipt of payment under this Agreement. Seller further agrees </Text>

                    <Text style={styles.text}>
                        to provide COMPANY with reasonable assistance in the event of a government audit. COMPANY shall have no responsibility to pay or withhold from any payment to Seller under this Agreement, any federal, state, or local taxes or fees. COMPANY will regularly report amounts paid to Seller by filing forms with the Federal Internal Revenue Service.    
                    </Text>
                    
                    <Text style={styles.boldText}>9. INSURANCE.</Text>
                    <Text style={styles.text}>
                        Seller shall be solely responsible for maintaining and requiring Seller's Assistants to maintain such adequate health, auto, workers' compensation, unemployment compensation, disability, liability, and other insurance, as is required by law or as is the common practice in Seller's and Seller's Assistants' trades or businesses, whichever affords greater coverage. Upon request, Seller shall provide COMPANY with certificates of insurance or evidence of coverage before commencing performance under this Agreement. Seller shall provide adequate coverage for any COMPANY property under the care, custody or, control of Seller or Seller's Assistants.</Text>

                    <Text style={styles.boldText}>10. INDEMNITY.</Text>
                    <Text style={styles.text}>
                        Seller shall indemnify, hold harmless, and at COMPANY's request, defend COMPANY, its officers, directors, customers, agents and employees, against all claims, liabilities, damages, losses, and expenses, including attorneys' fees and cost of suit arising out of or in any way connected with the Goods or Services provided under this Agreement, including, without limitation, (i) any claim based on the death or bodily injury to any person, destruction or damage to property, or contamination of the environment and any associated clean up costs, (ii) Seller failing to satisfy the Internal Revenue Service's guidelines for an independent contractor, (iii) any claim based on the negligence, omissions, or willful misconduct of Seller or any Seller's Assistants, and (iv) any claim by a third party against COMPANY alleging that the Goods or Services, the results of such Services, or any other products or processes provided under this Agreement, infringe a patent, copyright, trademark, trade secret, or other proprietary right of a third party, whether such are provided alone or in combination with other products, software, or processes. Seller shall not settle any such suit or claim without COMPANY's prior written approval. Seller agrees to pay or reimburse all costs that may be incurred by COMPANY in enforcing this indemnity, including attorneys' fees. Should COMPANY's use, or use by its distributors, subcontractors, or customers, of any Goods or Services purchased from Seller be enjoined, be threatened by injunction, or be the subject of any legal proceeding, Seller shall, at its sole cost and expense, either (a) substitute fully equivalent non-infringing Goods or Services; (b) modify the Goods or Services so that they no longer infringe but remain fully equivalent in functionality; (c) obtain for COMPANY, its distributors, subcontractors, or customers the right to continue using the Goods or Services; or (d) if none of the foregoing is possible, refund all amounts paid for the infringing Goods or Services.
                    </Text>

                    <Text style={styles.boldText}>11. CONFIDENTIALITY.</Text>
                    <Text style={styles.text}>
                        Seller will acquire knowledge of COMPANY Confidential Information (as defined below) in connection with its performance hereunder and agrees to keep such
                        COMPANY Confidential Information in confidence during and following termination or expiration of this Agreement. "COMPANY Confidential Information"
                        includes but is not limited to all information, whether written or oral, in any form, including without limitation, information relating to the research, development,
                        products, methods of manufacture, trade secrets, business plans, customers, vendors, finances, personnel data, Work Product (as defined herein), and other
                        material or information considered proprietary by COMPANY relating to the current or anticipated business or affairs of COMPANY which is disclosed directly
                        or indirectly to Seller. In addition, COMPANY Confidential Information means any third party's proprietary or confidential information disclosed to Seller in the
                        course of providing Services or Goods to COMPANY. COMPANY Confidential Information does not include any information (i) which Seller lawfully knew
                        without restriction on disclosure before COMPANY disclosed it to Seller, (ii) which is 
                    </Text>
                    <Text style={[styles.textUnderline]}>
                        {"________________________________________________________________________________"}
                    </Text>
                    <Text style={[styles.footerTextLeft]}>RS-SCD-PMG-PUR-P-10106 PROCUREMENT</Text>
                    <Text style={[styles.textRight]}>Unauthorized Printing Is Not Permitted</Text>

                </View>
            </View>
        </>
    )
}

export default PageFour;
